<script setup>
import { useI18n } from 'vue-i18n';
import { FIANLY_VERSION } from './release';
import copy from './en.json';

const { t } = useI18n({
  useScope: 'local',
  messages: copy.VERSION_LOCALES,
  fallbackLocale: 'en',
});
const environmentKey = import.meta.env.DEV ? 'DEVELOPMENT' : 'PRODUCTION';
</script>

<template>
  <p class="text-center text-xs leading-5 text-n-slate-11" data-fianly-version>
    {{
      t('LABEL', { environment: t(environmentKey), version: FIANLY_VERSION })
    }}
  </p>
</template>
